'use strict';

let StorageObj = {
  check: function(key){
    var storage = window[key+'Storage'];
    try {
      storage.setItem('test', 'test');
      storage.removeItem('test');
      return true;
    } catch (e) {
      return false;
    }
  },
  init: function(){
    console.log('storage.init()');
    this.local = this.check('local');
    this.session = this.check('session');
    return this;
  }
};
const storage = StorageObj.init();

export default storage;
